import styled, { css } from 'styled-components';

import Input from 'basics/inputs/Input';
import Select from 'basics/inputs/Select';
import ToggleGroup from 'basics/inputs/ToggleGroup';

import { flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints } from 'styles/style-constants';

export const Header = styled.div`
    ${flexRowSpaceBetween};
    margin-top: 3.2rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        margin-top: 0;
        padding: 1.6rem 0;
    `}
`;

const togglePlacement = css`
    width: fit-content;
    margin-top: 3.6rem;
    margin-bottom: 3.2rem;

    ${respondDown(Breakpoints.sm)`
        display: none;
    `}
`;

export const ToggleGroupStyled = styled(ToggleGroup)`
    ${togglePlacement}
`;
export const FilterPlaceholder = styled.div`
    ${togglePlacement}
`;

const selectPlacement = css`
    margin-top: 3.6rem;
    display: none;

    ${respondDown(Breakpoints.sm)`
        display: flex;
        margin-bottom: 3.2rem;
        margin-top: 1.6rem;
    `}
`;

export const SelectStyled = styled(Select)`
    ${selectPlacement}
`;
export const SelectPlaceholder = styled.div`
    ${selectPlacement}
`;

const inputPlacement = css`
    width: 56rem;
    margin-left: 2.4rem;

    ${respondDown(Breakpoints.md)`
        width: 100%;
        margin-left: 0;
    `}
`;

export const StyledInput = styled(Input)`
    ${inputPlacement}
`;
export const SearchPlaceholder = styled.div`
    ${inputPlacement}
`;

export const TitleWithTooltip = styled.span`
    display: flex;
    align-items: center;

    svg {
        margin: 0 0.4rem;
    }
`;

export const TooltipInnerHead = styled.span`
    width: 20rem;
    white-space: pre-wrap;
    font-size: 1.4rem;
    line-height: 2rem;
`;
